import React from "react";
import { Modal, Button } from "rsuite";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
};

function ReasonModal({ open, setOpen, reason, reasonTitle }) {
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Modal.Header closeButton={true}>
        <Modal.Title>
          <div>{reasonTitle}原因</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ padding: "32px 0px", whiteSpace: "pre-wrap" ,lineHeight:'24px'}}>
          {reason}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button appearance="primary" onClick={handleClose}>
          確認
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ReasonModal;
